import { Core } from "@/core/Core";

export default {

  async getPosRoles(context, companyId) {
    try {
      return await Core.request("GET", `/api/companies/${companyId}/pos_roles`);
    } catch (e) {
      return null;
    }
  },

  async getRevenueCenters(context, companyId) {
    try {
      return await Core.request("GET", `/api/companies/${companyId}/revenue_centers`);
    } catch (e) {
      return null;
    }
  },

  async deleteRevenueCenter(context, revenueCenterId) {
    try {
      return await Core.request("DELETE", `/api/revenue_centers/${revenueCenterId}`);
    } catch (e) {
      return null;
    }
  },

  async getRevenueCenter(context, revenueCenterId) {
    try {
      return await Core.request("GET", `/api/revenue_centers/${revenueCenterId}`);
    } catch (e) {
      return null;
    }
  },

  async saveRevenueCenter(context, revenueCenter) {
    try {
      return await Core.request("PUT", `/api/revenue_centers/${revenueCenter.id}`, revenueCenter);
    } catch (e) {
      return null;
    }
  },

  async createRevenueCenter(context, revenueCenter) {
    try {
      return await Core.request("POST", `/api/revenue_centers`, revenueCenter);
    } catch (e) {
      return null;
    }
  },

  async getPosPermissions(context) {
    try {
      return await Core.request("GET", "/api/pos_util/permissions");
    } catch (e) {
      return null;
    }
  },

  async getPosFunctions(context) {
    try {
      return await Core.request("GET", "/api/pos_util/functions");
    } catch (e) {
      return null;
    }
  },

  async getPosRole(context, roleId) {
    try {
      return await Core.request("GET", `/api/pos_roles/${roleId}`);
    } catch (e) {
      return null;
    }
  },

  async deletePosRole(context, roleId) {
    try {
      return await Core.request("DELETE", `/api/pos_roles/${roleId}`);
    } catch (e) {
      return null;
    }
  },

  async savePosRole(context, data) {
    try {
      return await Core.request("PUT", `/api/pos_roles/${data.id}`, data);
    } catch (e) {
      return null;
    }
  },

  async createPosRole(context, data) {
    try {
      return await Core.request("POST", `/api/pos_roles`, data);
    } catch (e) {
      return null;
    }
  },

  async getTipEntry(context, { company, tipId }) {
    try {
      return await Core.request("GET", `/api/tip_entries/${tipId}?company=${company}`);
    } catch (e) {
      return null;
    }
  },

  async createTipEntry(context, { company, employee, amount, date, currency }) {
    try {
      return await Core.request("POST", `/api/tip_entries?company=${company}`, {
        employeePin: 1,
        password: null,
        employee,
        amount,
        date,
        currency
      });
    } catch (e) {
      return null;
    }
  },

  async editTipEntry(context, { tipId, company, employee, amount, date, currency }) {
    try {
      return await Core.request("PUT", `/api/tip_entries/${tipId}?company=${company}`, {
        employeePin: 1,
        password: null,
        employee,
        amount,
        date,
        currency
      });
    } catch (e) {
      return null;
    }
  },

  async getBatch(context, { batchId }) {
    try {
      return await Core.request("GET", `/api/batches/${batchId}`);
    } catch (e) {
      return null;
    }
  }
}